import 'dom-slider'

class Slide {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = {
            elemToChange: 'next',
            action: 'toggle',
            delay: 0,
            maxWidth: 99999999999,
            minWidth: 0,
            addHideClass: false,
            ...JSON.parse(this._elem.getAttribute('data-slide') || '{}')
        }
        this._mq = window.matchMedia(`(min-width: ${this._data.minWidth}px) and (max-width: ${this._data.maxWidth}px)`)
    }

    onInit () {
        const element = this._getElement(this._data.elemToChange)
        if (this._data.addHideClass && element) {
            this._sortClasses(this._mq, element)

            this._mq.addEventListener('change', (mq) => {
                this._sortClasses(mq, element)
            })
        }

        this._elem.addEventListener('click', () => {
            if (this._mq.matches) {
                if (element) {
                    this._slide(element, this._data.action)
                    if (this._data.closeSiblings) this._closeSiblings(element)
                    if (element.querySelector('video')) {
                        element.querySelector('video').pause()
                        element.querySelector('[data-video-play-button]').classList.remove('visually-hidden')
                    }
                    if (element.querySelector('iframe')) {
                        const source = element.querySelector('iframe').getAttribute('src')
                        element.querySelector('iframe').removeAttribute('src')
                        element.querySelector('iframe').setAttribute('src', source)
                    }
                }
            }
        })
    }

    _getElement (element) {
        switch (element) {
        case 'next':
            return this._elem.nextElementSibling
        case 'prev':
            return this._elem.previousElementSibling
        case 'parent':
            return this._elem.parentNode
        case 'child':
            return this._elem.childElementSibling
        default:
            return document.querySelector(element)
        }
    }

    _slide (element, action) {
        const {slideDown, slideUp, slideToggle} = window.domSlider
        const {delay} = this._data
        switch (action) {
        case 'show':
            slideDown({element, delay})
            break
        case 'hide':
            slideUp({element, delay})
            break
        case 'toggle':
            slideToggle({element, delay})
            break
        default:
            slideToggle({element, delay})
        }
    }

    _closeSiblings (elem) {
        const {slideUp} = window.domSlider
        const siblings = document.querySelectorAll(this._data.closeSiblings)
        siblings.forEach(sibling => {
            if (sibling !== elem) {
                if (this._data.closeSiblingsElement) {
                    slideUp({element: sibling.querySelector(this._data.closeSiblingsElement)})
                } else {
                    slideUp({element: sibling})
                }
            }
        })
    }
    _sortClasses (mq, target) {
        if (mq.matches) {
            target.classList.add('DOM-slider-hidden')
        } else {
            target.classList.remove('DOM-slider-hidden')
        }
    }
}

export default Slide



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slide.js